import api from "./api";

async function getOpenBankingPayment(id) {
  try {
    const response = await api.get("api/openbankingpayments/" + id);
    return response.data;
  } catch (error) {
    return [];
  }
}

async function createOpenBankingPayment(
  merchantId,
  paymentRequestId,
  customerId,
  orderNumber,
  checkoutId,
  customerName,
  amount,
  reference,
  institutionId,
  callbackUrl,
  source,
  branchId,
  customerEmail,
  customerIsFinanced,
  ledgerTransactionIds,
  salesOrderIds,
  discounts = null,
  token = null) {
  try {
    const response = await api.post(
      `api/openbankingpayments`,
      {
        merchantId,
        paymentRequestId,
        customerId,
        orderNumber,
        checkoutId,
        customerName,
        amount,
        reference,
        institutionId,
        callbackUrl,
        source,
        branchId,
        customerEmail,
        customerIsFinanced,
        ledgerTransactionIds,
        salesOrderIds,
        discounts,
        token,
      }
      ,{ bypassInterceptor: true }
    );
    return response;
  } catch (error) {
    if (error.response?.status === 401 && error.response.data?.code === "TokenExpired")
      return { tokenExpired: true };
    return [];
  }
}

async function authoriseOpenBankingPayment(paymentId, consent) {
  try {
    const response = await api.post(
      `api/openbankingpayments/${paymentId}/authorise`,
      {
        consent
      }
    );
    return response.data;
  } catch (error) {
    return [];
  }
}

async function failOpenBankingPayment(paymentId, error) {
  try {
    const response = await api.post(
      `api/openbankingpayments/${paymentId}/fail`,
      {
        error
      }
    );
    return response.data;
  } catch (error) {
    return [];
  }
}

export {
  getOpenBankingPayment,
  createOpenBankingPayment,
  authoriseOpenBankingPayment,
  failOpenBankingPayment
};
